<template>
	<div class="view view__login">
		<div class="view__login-content">
			<img :src="logo.src" alt="Trunk CMS" :width="logo.width" :height="logo.height">
			<login-form @loginSuccess="loginSuccess" @loginFail="loginFail" @resetSuccess="resetSuccess" @resetFail="resetFail"></login-form>
		</div>
	</div>
</template>

<script>
	// Dependencies
	import LoginForm from '@/components/LoginForm'

	// Export
	export default {
		name: 'LoginView',
		components: {
			LoginForm,
		},
		methods: {
			loginSuccess(user) {
				this.$router.push({ name: 'content' })
			},
			loginFail(err) {
				this.$dialog(err)
			},
			resetSuccess(data) {
				this.$dialog(`A password reset email has been sent to: <strong>${data.email}</strong>`, {
					cancelText: 'OK',
				})
			},
			resetFail(err) {
				this.$dialog(err)
			},
		},
		computed: {
			logo() {
				// Hard-coded, for now
				let logo = {
					src: require('@/assets/images/trunk-cms_logo.svg'),
					height: 82,
					width: 75,
				}
				const domains = (window.location.host).split('.')
				const sub = domains[0]
				switch (sub) {
				case 'jha':
					logo = {
						src: require('@/assets/images/jha-associates_logo.png'),
						height: 56,
						width: 248,
					}
					break
				case 'oac':
					logo = {
						src: require('@/assets/images/oac_logo.png'),
						height: 64,
						width: 112,
					}
					break
				default:
					break
				}
				return logo
			},
		},
	}
</script>

<style scoped lang="scss">
	.view__login {
		align-items: center;
		background-color: color_('background');
		display: flex;
		justify-content: center;
		flex: 1;
		flex-direction: column;

		&-content {
			background-color: color_('white');
			box-shadow: $whiteframe2;
			display: flex;
			flex-direction: column;
			justify-content: center;
			max-width: 480px;
			text-align: center;
			width: 100vh;
			@include gutter('padding');

			img {
				align-self: center;
				@include gutter('margin-bottom');
				// margin-left: auto;
				// margin-right: auto;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue